// [Chargebee V1 Remediation]
// Keep propertyId around so we can have the same method signature when we switch back to the LMG API
/* eslint-disable no-unused-vars */
/* eslint-disable-next-line no-redeclare */
/* globals fetch */

import client from '../services/client';

const ENV = process.env.REACT_APP_ENV === 'prod' ? 'prod' : 'dev';
const BASE_URL = `https://us-central1-gitl-firebase-${ENV}.cloudfunctions.net`;

const firebaseRequest = async (path, payload, method) => {
  const fetchConfig = {
    method,
    headers: payload ? { 'Content-Type': 'application/json' } : undefined,
    body: payload ? JSON.stringify(payload) : undefined,
  };

  const res = await fetch(`${BASE_URL}/${path}`, fetchConfig);

  let json;
  try {
    json = await res.json();
  } catch (err) {
    json = null;
  }

  if (res.ok) {
    return json;
  }

  const err = new Error((json && json.error) || 'Unexpected Error. Contact Support.');
  err.code = json.code;
  err.cause = res;

  throw err;
};

const checkout = async ({ propertyId, businessId, itemPriceId }) => {
  const token = await client.auth.authProvider.getTokens();

  if (!token) throw new Error('Not logged in');

  const lmgToken = token && token.access;
  const targetChargebeePlanId = itemPriceId;
  const businessAuthData = {
    lmgToken,
    businessId,
    targetChargebeePlanId,
  };

  return firebaseRequest('payments/1/chargebee/upgrade-plan', businessAuthData, 'POST');
};

const initializeCustomer = async ({
  createdByEmail,
  company,
  email,
  propertyId,
  businessId,
  billingAddress,
}) => {
  const token = await client.auth.authProvider.getTokens();

  if (!token) throw new Error('Not logged in');

  const lmgToken = token && token.access;

  const payload = {
    businessId,
    createdByEmail,
    company,
    email,
    billingAddress,
    lmgToken,
  };
  return firebaseRequest('payments/1/chargebee/customer', payload, 'POST');
};

const initializeBillingAddress = async ({
  line1,
  city,
  stateCode,
  zip,
  country,
  company,
  propertyId,
  businessId,
}) => {
  const token = await client.auth.authProvider.getTokens();

  if (!token) throw new Error('Not logged in');

  const lmgToken = token && token.access;

  const payload = {
    businessId,
    line1,
    city,
    stateCode,
    zip,
    country,
    company,
    lmgToken,
  };
  return firebaseRequest('payments/1/chargebee/customer/billingAddress', payload, 'POST');
};

const getBillingAddress = async ({
  businessId,
}) => {
  const token = await client.auth.authProvider.getTokens();

  if (!token) throw new Error('Not logged in');

  const lmgToken = token && token.access;

  return firebaseRequest(
    `payments/1/chargebee/customer/billingAddress?businessId=${businessId}&lmgToken=${lmgToken}`,
    null,
    'GET',
  );
};

// [Chargebee V1 Remediation] Do we even need this anymore? Is it done automatically by the server?
const syncPlan = async ({ businessId }) => {
  const token = await client.auth.authProvider.getTokens();

  if (!token) throw new Error('Not logged in');

  const lmgToken = token && token.access;

  return firebaseRequest(
    'payments/1/chargebee/syncPlan',
    {
      businessId,
      lmgToken,
    },
    'POST',
  );
};


const recordSocialPostFeedback = async ({
  date,
  businessName,
  reason,
  details,
  link,
}) => {
  return firebaseRequest(
    'api/2/socialai/feedback',
    {
      date,
      businessName,
      reason,
      details,
      link,
    },
    'POST',
  );
};

export {
  checkout,
  initializeCustomer,
  initializeBillingAddress,
  getBillingAddress,
  syncPlan,
  recordSocialPostFeedback,
};
